import * as actions from './inventoryVariant/actions'
import * as mutations from './inventoryVariant/mutations'
import * as getters from './inventoryVariant/getters'

import { dataProps } from './inventoryVariant/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps)),
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryVariant.js